<template>
  <nav class="nav-block container-fluid">
    <div class="nav-block__wrapper row justify-content-lg-between justify-content-center">
      <div class="d-lg-none nav-block__icon">
        <label for="checkbox">
          <img src="@/icons/menu.svg" alt="Voltar a página inícial" title="Voltar a página inícial">
        </label>
      </div>
      <div class="d-lg-block d-none nav-block__icon">
        <router-link :to="{ name: 'home'}">
          <img src="@/icons/home.svg" alt="Voltar a página inícial" title="Voltar a página inícial">
        </router-link>
      </div>
      <div class="col-12 col-lg-auto text-center d-lg-block order-last">
        <input class="nav-block__checkbox d-none" id="checkbox" type="checkbox" v-model="close">
        <ul class="nav-block__list">

          <li class="nav-block__item d-block d-lg-none">
            <router-link
              class="nav-block__link"
              :class="{'active': $route.name == 'home'}"
              :to="{ name: 'home' }"
            >
              Home
            </router-link>
          </li>

          <li class="nav-block__item">
            <a
              class="nav-block__link d-block d-lg-none"
              v-if="isHome"
              href="/#informacoes-gerais"
            >
              Informações
            </a>
            <a
              class="nav-block__link d-none d-lg-block"
              :class="{'active': $route.name == 'home'}"
              v-if="isHome"
              href="/#informacoes-gerais"
            >
              Informações
            </a>
            <router-link
              class="nav-block__link"
              :class="{'active': $route.name == 'home'}"
              v-if="!isHome"
              :to="{ name: 'home', hash: '#informacoes-gerais' }"
            >
              Informações
            </router-link>
          </li>

          <li class="nav-block__item" v-for="(route, index) in routes" :key="index" v-if="route.meta.showNav">
            <router-link class="nav-block__link" v-if="route.meta.hash" :to="{ name: route.name, hash: route.meta.hash }">{{ route.meta.label }}</router-link>
            <router-link class="nav-block__link" v-if="!route.meta.hash" :to="{ name: route.name }">{{ route.meta.label }}</router-link>
          </li>
        </ul>
      </div>
      <div class="nav-block__button col-auto order-lg-last">
        <div class="inscrevase">
          <router-link :to="{ name: 'inscrevase' }">
            <Button bradesco class="d-lg-none">Inscreva-se</Button>
            <Button border class="d-none d-lg-block">Inscreva-se</Button>
          </router-link>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import Button from '@/components/Button'
  import { routes } from '@/router'

  export default {
    name: 'Nav',
    data: () => ({
      routes,
      close: true,
    }),
    components: {
      Button
    },
    computed: {
      isHome() {
        return this.$route.name == 'home'
      },
      routeName() {
        return this.$route.name
      }
    },
    watch: {
      routeName() {
        this.close = true
      }
    }
  }
</script>

<style lang="scss">

  $vermelho: #eb2136;

  .nav-block
  {
    position: absolute;
    z-index: 20;
    top: 0;
    right: 0;
    left: 0;

    height: 90px;
    padding-right: 30px;
    padding-left: 30px;

    @media(max-width: 992px) {
      position: fixed;
      background: $vermelho;
    }

    &__wrapper
    {
      height: 100%;
    }

    &__icon
    {
      margin: 35px 15px;
      @media(max-width: 992px) {
        position: absolute;
        left: 0;
      }
    }

    &__button
    {
      margin: 25px 0;
    }

    &__item
    {
      display: block;
      margin: 34px 0;

      @media (min-width: 992px)
      {
        display: inline-block;
      }
    }

    &__list
    {
      @media (max-width: 991px)
      {
        position: absolute;
        right: 0;
        left: 0;
        top: -1px;
        display: block;
        background-color: $vermelho;
        border-top: 1px solid darken($vermelho, 10%)
      }
    }

    &__checkbox:checked + &__list
    {
      @media (max-width: 991px)
      {
        display: none;
      }
    }

    &__link
    {
      font-size: 18px;
      font-weight: 600;

      display: inline-block;

      margin: 0 20px;

      color: #fff;

      &.router-link-exact-active,
      &.active
      {
        padding-bottom: 3px;

        border-bottom: 1px solid #fff;
      }
    }
  }
</style>
